export default __webpack_public_path__ + "static/media/diagram.bb8e17b4.png";